<template>
  <div class="container-fluid overflow-auto">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs v-model="tab.tabIndex" class="mb-4">
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getHelpingMember"
    >
      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(seniority)="row">
        {{ row.item.seniority_month }}個月 ({{ row.item.seniority_day }}天)
      </template>

      <template #cell(pay_count)="row">
        <span class="link" @click="openPaidDetailsModal(row.item.number)">{{ row.item.pay_count }}</span>
      </template>

      <template #cell(function)="row">
        <b-button
          variant="success"
          size="sm"
          @click="openMutualListModal(row.item.id)"
        >
          互助名單
        </b-button>

        <b-button
          variant="danger"
          size="sm"
          @click="openDeadListModal(row.item.id)"
        >
          身故名單
        </b-button>

        <b-button
          variant="info"
          size="sm"
          @click="openMemberPostponementListModal(row.item)"
        >
          會員順延名單
        </b-button>
      </template>

      <template #cell(print)="row">
        <b-button
          v-if="row.item.claim_check"
          variant="secondary"
          size="sm"
          @click="generatePaymentSchedule(row.item)"
        >
          給付明細表
        </b-button>
      </template>
    </tables-page>

    <!-- 互助名單 modal -->
    <mutual-list-modal
      v-model="status.mutualListModal"
      :member_id="data.member_id"
      :isMaskData="true" />

    <!-- 身故名單 modal -->
    <dead-list-modal
      v-model="status.deadListModal"
      :member_id="data.member_id"
      :isMaskData="true" />

    <!-- 會員順延名單 modal -->
    <member-postponement-list-modal
      v-model="status.memberPostponementListModal"
      :data="data.temp_table_data"
      :isMaskData="true" />

    <!-- 已繳費細項 modal -->
    <paid-details-modal
      v-model="status.paidDetailsModal"
      :number="data.number" />

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :params="data.pdfParams"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <payment-schedule :data="data.temp_table_data"></payment-schedule>
      </template>
    </html-to-pdf>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import toHelpingOthersApi from "@/models/API/toHelpingOthersApi";
import { countNoNum, convertRocDate, getLocalUserInfo } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import PaymentSchedule from '@/components/common/PrintTemplate/PaymentSchedule';
import MemberPostponementListModal from '@/components/common/Modal/MemberPostponementListModal';
import MutualListModal from '@/components/common/Modal/MutualListModal';
import DeadListModal from '@/components/common/Modal/DeadListModal';
import PaidDetailsModal from '@/components/common/Modal/PaidDetailsModal';

export default {
  name: 'pay',
  components: {
    BreadCrumb,
    TablesPage,
    HtmlToPdf,
    PaymentSchedule,
    MemberPostponementListModal,
    MutualListModal,
    DeadListModal,
    PaidDetailsModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '契約管理', url: '', isActive: true },
          { name: '契約', url: '', isActive: false }
        ]
      },
      search: {
        number: '',
        name: '',
      },
      status: {
        isNew: false,
        resetDom: false,
        memberPostponementListModal: false,
        mutualListModal: false,
        deadListModal: false,
        paidDetailsModal: false
      },
      data: {
        table_data: [],
        page: {},
        temp_table_data: {},
        info: {},
        member_id: 0,
        number: '',
        pdfParams: {
          format: 'a5',
          orientation: 'p'
        },
      },
      tab: {
        items: [
          { value: 0, label: '正常' },
          { value: 1, label: '身故' },
          { value: 2, label: '停效' },
          { value: 3, label: '除會' },
        ],
        tabIndex: 0
      }
    }
  },
  watch: {
    'tab.tabIndex': {
      handler(newValue, oldValue) {
        this.getHelpingMember();
      },
      immediate: false
    }
  },
  computed: {
    tableFields() {
      let table_fields = [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "互助人姓名",
        },
        {
          key: "join_date",
          label: "入會日期"
        },
        {
          key: "beneficiary_name",
          label: "受款人"
        },
        {
          key: "seniority",
          label: "年資"
        },
        {
          key: "pay_count",
          label: "繳費次數"
        },
      ]

      if (this.tab.tabIndex === 0) {
        table_fields.push(
          {
            key: "function",
            label: "功能"
          }
        )
      } else if (this.tab.tabIndex === 1) {
        table_fields.push(
          {
            key: "print",
            label: "列印"
          }
        )
      }

      return table_fields;
    }
  },
  mounted() {
    this.toHelpingOthersApi = new toHelpingOthersApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.toHelpingOthersApi.page);
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
      this.getHelpingMember();
    },
    countNoNum,
    convertRocDate,
    // 查詢要助人契約
    getHelpingMember(pageIndex = null) {
      const params = {
        'status': this.tab.tabIndex,
        'pay_ID_number': this.data.info.account,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.toHelpingOthersApi.getHelpingMember((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數

        this.data.table_data = res.data;
      }, params)
    },
    // 產生給付明細表
    async generatePaymentSchedule(item = {}) {
      this.status.resetDom = true;

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    },
    // 開啟會員順延名單 modal
    openMemberPostponementListModal(item = null) {
      this.status.memberPostponementListModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 開啟互助名單 modal
    openMutualListModal(id = 0) {
      this.status.mutualListModal = true;
      this.data.member_id = id;
    },
    // 開啟身故名單 modal
    openDeadListModal(id = 0) {
      this.status.deadListModal = true;
      this.data.member_id = id;
    },
    // 開啟已繳費細項 modal
    openPaidDetailsModal(number) {
      this.status.paidDetailsModal = true;
      this.data.number = number;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/toHelpingOthers/contract.vue